const p9 = {
    install(Vue) {
        Vue.prototype.$p9 = {
            uid: function (len) {   
                let uid = '', num = len || 25;               
                let IDX = 36, HEX = '';
                while (IDX--) HEX += IDX.toString(36);
                while (num--) uid += HEX[Math.random() * 36 | 0];
                return uid;
            },
            parse: {
                float(str) {
                    return Number(typeof str === 'string'? str.replace(/[^0-9](\d{2}$)/gi, '.$1').replace(/[^\d\.]/gi, '') : str)
                },
                money(str) {
                    let parsed = Vue.prototype.$p9.parse.float(str).toFixed(2)
                    return `${new Intl.NumberFormat().format(parsed)} $`
                },
            },
            str: {
                capitalize(str) {
                    return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1)
                },
                removeAccents(str) {
                    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                },
                comparableString(str) {
                    return Boolean(str) ? Vue.prototype.$p9.str.removeAccents(str.toString().toUpperCase().trim()) : null
                },
            },
            test: {
                isUrl(string) {
                    try {
                        return Boolean(new URL(string))
                    } catch (e) {
                        return false
                    }
                },
            },
            dates: {
                dateTransator(val) {
                    return val.replace(/[Jj][Aa][Nn][A-z\.]*/g,'Janvier').replace(/[Ff][Ee][Bb][A-z\.]*/g,'Février').replace(/[Mm][Aa][Rr][A-z\.]*/g,'Mars').replace(/[Aa][Pp][Rr][A-z\.]*/g,'Avril').replace(/[Mm][Aa][Yy][A-z\.]*/g,'Mai').replace(/[Jj][Uu][Nn][A-z\.]*/g,'Juin').replace(/[Jj][Uu][Ll][A-z\.]*/g,'Juillet').replace(/[Aa][Uu][Gg][A-z\.]*/g,'Août').replace(/[Ss][Ee][Pp][A-z\.]*/g,'Septembre').replace(/[Oo][Cc][Tt][A-z\.]*/g,'Octobre').replace(/[Nn][Oo][Vv][A-z\.]*/g,'Novembre').replace(/[Dd][Ee][Cc][A-z\.]*/g,'Décembre');
                },
                isExpired(date) {
                    return new Date().toISOString().split('T')[0] > date
                },
            },
            arrays: {
                sum(items) {
                    return items.reduce((a, b) => {
                        return a + Vue.prototype.$p9.parse.float(b)
                    }, 0)
                },
                listSum(items, prop){
                    return items.reduce((a, b) => {
                        return a + Vue.prototype.$p9.parse.float(b[prop])
                    }, 0)
                },
                singleOccurrence(arr) {
                    return arr.filter(i => arr.filter(j => i === j).length === 1)
                },
            },
            objects: {
                incMapping(obj, incProps) {
                    return Object.fromEntries(Object.entries(obj).filter(([k, v]) => incProps.indexOf(k) > -1))
                },
                excMapping(obj, excProps) {
                    return Object.fromEntries(Object.entries(obj).filter(([k, v]) => excProps.indexOf(k) === -1))
                },
                sortList(list, prop, order) {
                    return list.sort(Vue.prototype.$p9.objects.compareValues(prop, order))
                },
                compareValues(key, order = 'asc') {
                    return function innerSort(a, b) {
                        a = Array.isArray(a) ? a[1] : a
                        b = Array.isArray(b) ? b[1] : b

                    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0
                    const comparison = a[key].localeCompare(b[key])
                
                    return (
                        (order === 'desc') ? (comparison * -1) : comparison
                    )
                    }
                },
            },
        }
}
}

export default p9